// Routes
import routes, { TRoute } from 'router/routes';

const isNavItem = ({ isNavigate, label }: TRoute) => isNavigate && label !== 'helpPage';

const NAV_ROUTES = routes.filter(isNavItem);

// What the header nav shows before the user has any history: every top-level page, in the order
// the routes are declared. NavigationMemory drops the ones the user may not open.
export const DEFAULT_NAV_LABELS = NAV_ROUTES.map(({ label }) => label);

const COMPANY_SEGMENT_INDEX = 2;

/**
 * The top-level nav item a detail page belongs to (a company's card -> Companies), found by the
 * first path segment after the company name, the same one NavigationMemory marks as active.
 */
export const getSectionNavLabel = (pathname: string): string | undefined => {
  const section = pathname.split('/')[COMPANY_SEGMENT_INDEX];

  return NAV_ROUTES.find(({ path }) => path.split('/')[COMPANY_SEGMENT_INDEX] === section)
    ?.label;
};
